export default {
  ADVANCED_FILTERING: 'advancedFiltering'
};
